export type ArticleKind = "tip" | "article";
export type ArticleStatus = "draft" | "published" | "archived";

export const KIND_LABEL: Record<ArticleKind, string> = { tip: "Tip", article: "Artikel" };
export const STATUS_LABEL: Record<ArticleStatus, string> = {
  draft: "Draf",
  published: "Terbit",
  archived: "Diarsipkan",
};

/** One row of GET /v2/admin/articles (no body). */
export interface AdminArticleRow {
  id: string;
  slug: string;
  kind: ArticleKind;
  title: string;
  summary: string;
  coverImageUrl: string | null;
  tags: string[];
  readingMinutes: number;
  relatedAssessmentCode: string | null;
  publishedAt: string | null;
  status: ArticleStatus;
  isPlaceholder: boolean;
  featuredOn: string | null;
  updatedAt: string;
  updatedBy: string | null;
  updatedByUsername: string | null;
}

export interface ArticleListFilter {
  status?: ArticleStatus;
  kind?: ArticleKind;
  q?: string;
  placeholder?: boolean;
  page: number;
  limit: number;
}

export type ArticleBlock =
  | { type: "heading"; level: 2 | 3; text: string }
  | { type: "paragraph"; text: string }
  | { type: "bullets"; items: string[] }
  | { type: "numbered"; items: string[] }
  | { type: "quote"; text: string }
  | { type: "image"; url: string; alt: string };

/** GET /v2/admin/articles/:id: the stored row, including the source text the admin typed. */
export interface ArticleDetail extends Omit<AdminArticleRow, "updatedByUsername"> {
  bodySource: string;
  bodyBlocks: ArticleBlock[];
}

/** Body of POST / PUT /v2/admin/articles. Status, slug and publish date are never sent. */
export interface ArticleInput {
  title: string;
  summary: string;
  kind: ArticleKind;
  bodySource: string;
  coverImageUrl: string | null;
  tags: string[];
  relatedAssessmentCode: string | null;
  isPlaceholder: boolean;
}

export type StatusAction = "publish" | "unpublish" | "archive" | "restore";

export interface PreviewResult {
  blocks: unknown[];
  warnings: string[];
  readingMinutes: number;
}

export interface AssessmentOption {
  code: string;
  name: string;
}
